
<template>

<v-app id="app">
<!-- <home></home>  <v-app id="app"> -->
 <CoreView></CoreView> 
 <AdminFooter></AdminFooter>
 <PerfilOpciones></PerfilOpciones>
    </v-app>
</template>

<script>

import home from '@/views/Home3'
import CoreView from '@/components/common/View'
import PerfilOpciones from '@/components/common/PerfilOpciones.vue';
import AdminFooter from '@/components/common/AdminFooter';


export default {
  name: 'MenuHome',

  components: {
    home,
    CoreView,
    PerfilOpciones,
    AdminFooter
  }
};




</script>
